<template>
  <div class="lock-screen-wrapper">
    <v-container pt-70 px-0>
      <v-layout row wrap>
        <v-flex xs12 sm8 md4 mx-auto>
          <div class="mb-70">
            <p class="text-xs-center">
              <router-link to="/" class="d-block text-xs-center">
                <img
                  :src="appLogo"
                  class="img-responsive mb-3"
                  width="78"
                  height="78" />
              </router-link>
            </p>
          </div>
          <div class="lock-screen-block text-xs-center">
            <div class="s-user mb-4">
              <img class="rounded-circle img-responsive" src="/app/v1/static/avatars/user-9.jpg" width="143" height="143">
            </div>
            <h2 class="white--text">Jerry Cummings</h2>
            <v-form v-model="valid" class="mb-4">
              <v-text-field
                label="Password"
                v-model="password"
                :rules="passwordRules"
                type="password"
                color="white"
                required
                maxLength="255"
              ></v-text-field>
            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
    data: function() {
        return {
            appLogo: AppConfig.appLogo2,
            password: "",
            valid: false,
            passwordRules: [(v) => !!v || "Password is required"],
        };
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault();
        },
    },
};
</script>
